<template>
  <div>
    <AppDateRangePicker
      :start-date="from"
      :end-date="to"
      :min-date="minDate"
      :max-date="today"
      :date-limit="twoMonthsCount"
      :start-week-on="organization.start_week_on"
      :custom-ranges="customRanges"
      :current-zone="{ name: activeTimeZone.for }"
      :disabled="disabled"
      class="insights-datepicker"
      opens="right"
      @change="onInput"
    />
  </div>
</template>

<script>
import { formatInternalDate, createWithZone } from '~/utils/time_utils';
import { mapState, mapGetters } from 'vuex';

import { InsightsFilters, InsightsDateRanges } from '~/mixins';

export default {
  // Picking a date will emit a query object to the parent date Filter
  name: 'InsightsHeaderDateFilter',
  mixins: [InsightsFilters, InsightsDateRanges],
  props: {
    value: {
      type: Object,
      default: () => ({ from: moment(), to: moment() }),
    },
    settings: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  // Must be declared: without it the parent's @input listener falls through via $attrs onto the
  // root element, where bubbling native input events would invoke it with a DOM Event.
  emits: ['input'],
  data: () => ({
    triggeredOnMount: true,
    selected: '',
  }),
  computed: {
    ...mapState(['filters', 'organization']),
    ...mapGetters(['startWeekOn', 'activeTimeZone']),
    options() {
      return [];
    },
    today() {
      return createWithZone(moment().tz(this.activeTimeZone.for), null, this.activeTimeZone.for).format('YYYY-MM-DD');
    },
    minDate() {
      return createWithZone(moment(), null, this.activeTimeZone.for).subtract(6, 'months').format('YYYY-MM-DD');
    },
    from() {
      return createWithZone(this.selected.from, null, this.activeTimeZone.for);
    },
    to() {
      return createWithZone(this.selected.to, null, this.activeTimeZone.for);
    },
    twoMonthsCount() {
      const today = moment();
      const twoMonthsAgo = moment().subtract(2, 'months');

      return today.add(1, 'day').diff(twoMonthsAgo, 'days');
    },
    customRanges() {
      return [this.dateRanges.find((range) => range.id === 'this-week')];
    },
  },
  created() {
    this.selected = this.value;
  },
  mounted() {
    this.onInput({ start: this.from, end: this.to });
    this.triggeredOnMount = false;
  },
  methods: {
    onInput({ start, end }) {
      if (start && end) {
        this.selected = this.buildDateRangeFilterQuery({ start, end });

        const queryObject = {
          key: 'date',
          value: this.selected,
          initial: this.triggeredOnMount,
        };

        this.$emit('input', { query: queryObject });
      }
    },
    buildDateRangeFilterQuery({ start, end }) {
      // Converts the given id into the matching from/to filter
      // so that we can store it and use it as query params

      return {
        from: formatInternalDate(start),
        to: formatInternalDate(end),
        time_zone: this.filters.time_zone,
      };
    },
  },
};
</script>
